'use client'

import type { PropsWithChildren } from 'react'
import React from 'react'

import type { QueryClientConfig } from '@tanstack/react-query'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

function getQueryClient(config: QueryClientConfig) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        refetchInterval: false
      }
    },
    ...config
  })
}

export interface IDataProviderProps extends QueryClientConfig {
  area?: string
  queryClient?: QueryClient
}

export const DataProvider: React.FunctionComponent<PropsWithChildren<IDataProviderProps>> = ({
  children,
  area,
  queryClient,
  ...props
}) => {
  if (area) {
    localStorage.setItem('AREA', area)
  }

  return (
    <QueryClientProvider client={queryClient ?? getQueryClient(props)}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
